import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { filter, map, Observable, tap } from 'rxjs';
import { CohortsEditComponent } from './cohorts-edit/cohorts-edit.component';
import { CohortService } from './service/cohort.service';
import { Location } from '@angular/common';
import { CourseService } from '../service/course.service';
@Component({
	selector: 'app-cohorts',
	templateUrl: './cohorts.page.html',
	styleUrls: ['./cohorts.page.scss'],
})
export class CohortsPage implements OnInit {
	getCohortList$: Observable<any> = new Observable();
	showHeaderFilter = true;
	courseId: any;
	courseName$: Observable<any> = new Observable();
	constructor(
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,
		private cohortService: CohortService,
		private location: Location,
		private courseService: CourseService,
	) {
		//
	}

	ngOnInit() {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.courseId = locationPath[3];

		this.cohortService.loadCourseApi(this.courseId).subscribe();
		this.cohortService.loadCourseData(this.courseId).subscribe();
		this.getCohortList$ = this.cohortService.fetchCourseData(this.courseId);
		this.courseService.loadCoursesApi().subscribe();
		this.courseService.loadCourseDataApi().subscribe();
		this.courseName$ = this.courseService.fetchCourseData().pipe(
			map((data: any) => {
				if (data.data) {
					return data.data.find((course: any) => course.id == this.courseId);
				}
			}),
		);
	}
	//
	isCanOpenBox = true;

	async editCohort(courses: any, ev: any) {
		ev.stopPropagation();
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: CohortsEditComponent,
				componentProps: {
					courses,
					isUpdate: true,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	async addCohort() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: CohortsEditComponent,
				componentProps: {
					isCreate: true,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	deleteCourses(course: any, ev: any) {
		ev.stopPropagation();
	}

	viewInfo(id: any) {
		this.router.navigate([`app/courses/${this.courseId}/cohorts/info/${id}`]);
	}
}
